<template>
  <div v-if="headerData && pictures && project" class="project-container">
    <project-header :project="headerData" :completed="true" />
    <project-carousel
      v-if="pictures?.length > 0"
      :pictures="pictures"
      :stages="stages"
      :completed="true"
      :has_many="true"
      :projectIndex="project.id"
      :inTheViewPort="true"
    />
    <section
      v-if="project.monitored && chartData?.config && chartData?.data"
      class="project-data"
    >
      <chart-header
        :data="chartData.data.datasets"
        :completed="true"
        @filterChanged="updateChart"
      />
      <analytics-chart :options="chartData.config" :data="chartData.data" />
      <section class="summurize-section">
        <analytics-table :data="chartData.tabelsData" />
      </section>
    </section>

    <!-- <div id="map"></div> -->
    <!-- <div ref="mapContainer" class="map-container"></div> -->
  </div>
</template>

<script>
import projectHeader from '../reusableComponents/ProjectHeader.vue'
import projectCarousel from '../reusableComponents/ProjectCarousel.vue'
import analyticsChart from './components/AnalyticsChart.vue'
import chartHeader from './components/ChartHeader.vue'
import analyticsTable from './components/AnalyticsTable.vue'
import './stylesheets/main.scss'
import moment from 'moment'
import axios from 'axios'
// import "leaflet/dist/leaflet.css";
// import L from "leaflet";
// import "leaflet-kml";
// import "ol/ol.css";
// import Map from "ol/Map";
// import View from "ol/View";
// import KML from "ol/format/KML";
// import VectorLayer from "ol/layer/Vector";
// import VectorSource from "ol/source/Vector";
// import TileLayer from "ol/layer/Tile";
// import OSM from "ol/source/OSM";
// import XYZ from "ol/source/XYZ";

export default {
  components: {
    projectHeader,
    projectCarousel,
    analyticsChart,
    chartHeader,
    analyticsTable,
  },
  props: {
    project: Object,
    project_type: Object,
    country: Object,
    district_name: String,
    pictures: Array,
    donors: String,
    district_name: String,
  },
  data() {
    return {
      headerData: null,
      config: null,
      map: null,
      chartData: null,
      stages: null,
      emptyChart: {
        config: analyticsConfig,
        data: {
          labels: [],
          datasets: [],
        },
      },
    }
  },
  async created() {
    let projectsStagesFetch = await axios.post('/api/project_stages', {
      index: 0,
      totalCount: 50,
      additionalColumns: ['id', 'name', 'picture_caption'],
    })
    this.stages = projectsStagesFetch.data.data
    this.config = analyticsConfig
    let completedHeader = {
      project_name: this.project.name,
      completion_date: this.project.completion_date,
      description: this.project.description || '',
      population: this.project.population,
      location: {
        lat: parseFloat(this.project.latitude),
        lng: parseFloat(this.project.longitude),
      },
      project_type: {
        name: this.project_type.name,
        icon: this.project_type.icon_url,
        marker_icon: this.project_type.marker_icon_url,
      },
      project_country: {
        name: this.country.name,
        id: this.country.id,
        flag_url: this.country.flag_url,
      },
      donors: this.donors,
      district_name: this.district_name,
    }
    this.headerData = completedHeader
    if (this.project.monitored) {
      const dataForChart = await this.getDataForMainChart()
      if (!dataForChart) {
        this.chartData = this.emptyChart
        return
      }
      this.chartData = dataForChart
    }
  },
  methods: {
    async updateChart(params) {
      const dataForChart = await this.getDataForMainChart(params)
      if (!dataForChart) {
        this.chartData = this.emptyChart
        return
      }
      this.chartData = dataForChart
    },
    async getDataForMainChart(params = null) {
      let configForCurrChart = JSON.parse(JSON.stringify(this.config))
      let updateParams
      if (params) {
        updateParams = {
          value_types: ['Accumulative'],
          ...params,
          query: {
            id_in: [this.project.id],
          },
        }
      } else {
        updateParams = {
          aggregation: 'Daily',
          value_types: ['Accumulative'],
          ts_from: moment().subtract(29, 'days').format('YYYY-MM-DD'),
          ts_to: moment().format('YYYY-MM-DD'),
          query: {
            id_in: [this.project.id],
          },
        }
      }
      let data = await axios.post('/api/analytics/monitorings', updateParams)
      let dataForMainChart = data.data

      let { labels, formmatedLabels } = this.getLabels([
        updateParams.ts_from,
        updateParams.ts_to,
      ])

      let { dataSetsFromDB } = organizeDatasets(dataForMainChart, labels)
      if (dataSetsFromDB.length === 0) return

      let flattenDatasets = dataSetsFromDB.flat()
      flattenDatasets = flattenDatasets.filter((set) => {
        if (set?.data?.length > 0) {
          return set
        }
      })
      if (flattenDatasets.length === 0) return

      let tempScales = flattenDatasets.map((data) => {
        return {
          group: data.group,
          unit: data.unit,
        }
      })
      let dataForTabels = dataForMainChart.map((data) => {
        return getDataSetForAccumulative(data, labels)
      })
      dataForTabels = dataForTabels.filter((obj) => {
        if (obj.data.length !== 0) return obj
      })
      tempScales = removeDuplicatesScales(tempScales)
      let currentScales = createScaleObject(tempScales)
      configForCurrChart.scales = currentScales
      return {
        data: {
          labels: formmatedLabels,
          datasets: flattenDatasets,
        },
        config: configForCurrChart,
        tabelsData: dataForTabels,
        aggregation: 'Daily',
      }
    },
    formatDate(dateStr) {
      const date = new Date(dateStr)
      const day = date.getDate()
      const month = date.toLocaleString('default', { month: 'short' })
      return `${day}. ${month}`
    },
    getLabels(date) {
      let labels = getDatesBetween(date)
      let formmatedLabels = labels.map((label) =>
        moment(label).format('YYYY-MM-DD')
      )
      formmatedLabels = labels.map((label) => this.formatDate(label))
      return {
        labels,
        formmatedLabels,
      }
    },
  },
  // mounted() {
  //   const mapContainer = this.$refs.mapContainer;
  //   const view = new View({
  //     projection: 'EPSG:4326',
  //     center: [this.headerData.location.lng, this.headerData.location.lat],
  //     zoom: 8,
  //   });

  //   const map = new Map({
  //     layers: [
  //       new TileLayer({
  //         source: new XYZ({
  //           url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
  //           maxZoom: 19,
  //         }),
  //       }),
  //       new TileLayer({
  //         source: new OSM(),
  //       }),
  //       new VectorLayer({
  //         source: new VectorSource({
  //           url: '../../../../../assets/anotherFile.kml',
  //           format: new KML({
  //             extractStyles: true,
  //           }),
  //         }),
  //       }),
  //     ],
  //     target: mapContainer,
  //     view: view,
  //   });
  // },
  // mounted() {
  //   let map = L.map("map").setView(
  //     [this.headerData.location.lat, this.headerData.location.lng],
  //     13
  //   );

  //   let streetLayer = L.tileLayer(
  //     "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
  //     {
  //       // maxZoom: 17,
  //       // minZoom: 0,
  //     }
  //   );

  //   let satelliteLayer = L.tileLayer(
  //     "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
  //     {
  //       // maxZoom: 17,
  //       // minZoom: 0,
  //     }
  //   );

  //   let baseLayers = {
  //     Satellite: satelliteLayer,
  //     "Street Map": streetLayer,
  //   };

  //   L.control.layers(baseLayers).addTo(map);
  //   satelliteLayer.addTo(map);

  //   fetch("../../../../../assets/god.kml")
  //     .then((res) => res.text())
  //     .then((kmltext) => {
  //       const parser = new DOMParser();
  //       const kml = parser.parseFromString(kmltext, "text/xml");

  //       const track = new L.KML(kml);

  //       map.addLayer(track);

  //       const bounds = track.getBounds();
  //       map.fitBounds(bounds);
  //     });
  // },
}
</script>

<style>
#map {
  height: 350px;
  margin-bottom: 2rem;
}
.map-container {
  height: 500px;
  width: 100%;
  margin-bottom: 2rem;
}
.map {
  height: 100%;
  width: 100%;
}
</style>
